import React, { useEffect, useRef, useState } from 'react';
import List from './components/List';
import { DELIVERY_INFO_MODS } from '../../../../config';
import Info from './components/Info';
import Button from '../../../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetDeliveryList } from '../../../../actions/admin';

const DeliveryInfo = (props) => {
  const { values, handleSubmit } = props;
  const [mode, setMode] = useState(DELIVERY_INFO_MODS.LIST);
  const [currentDelivery, setCurrentDelivery] = useState(null);
  const targetElement = useRef();
  const { servicesAndProducts } = useSelector((state) => state.admin);
  const [services, setServices] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (servicesAndProducts !== null) {
      const newServices = servicesAndProducts
        .map((item) => {
          return {
            label: item.deliveryCompanyName,
            value: item.deliveryCompany,
            products: item.deliveryCompanyProducts,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
      setServices(newServices);
    }
  }, [servicesAndProducts]);

  const handleSwitchMode = (mode, delivery) => {
    setMode(mode);
    if (delivery) {
      setCurrentDelivery(delivery);
    }
    const el = targetElement;
    el.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  };

  useEffect(() => {
    dispatch(fetchGetDeliveryList());
  }, []);

  const displayDeliveryComponent = () => {
    switch (mode) {
      case DELIVERY_INFO_MODS.LIST:
        return (
          <List
            values={values}
            handleSubmit={handleSubmit}
            handleSwitchMode={handleSwitchMode}
            mode={mode}
            services={services}
          />
        );
      case DELIVERY_INFO_MODS.INFO:
        return (
          <Info
            handleSwitchMode={handleSwitchMode}
            mode={mode}
            item={currentDelivery}
            services={services}
          />
        );
      case DELIVERY_INFO_MODS.EDIT:
        return (
          <Info
            handleSwitchMode={handleSwitchMode}
            mode={mode}
            item={currentDelivery}
            services={services}
          />
        );
      default:
        return <p>Загрузка</p>;
    }
  };

  return (
    <div ref={targetElement}>
      <div
        className="border-bottom"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: '20px',
        }}
      >
        <h4 className="header-title">Доставка</h4>

        {mode === DELIVERY_INFO_MODS.LIST && (
          <Button
            text="Создать договор"
            onClick={() => handleSwitchMode(DELIVERY_INFO_MODS.EDIT, {})}
          />
        )}
      </div>
      {displayDeliveryComponent()}
    </div>
  );
};

export default DeliveryInfo;
